export const formatCpfHiddenNumberMask = (cpf: string): string => {
  const cleanedCpf = cpf?.replace(/\D/g, '');

  if (cleanedCpf.length !== 11) {
    throw new Error('O CPF deve ter 11 dígitos');
  }

  const maskedCpf = cleanedCpf?.replace(/^(\d{3})(\d{3})/, '***.***');

  return maskedCpf?.replace(/(\d{3})(\d{2})$/, '$1-$2');
};


export const mascaraCpf = (cpf: string): string => {
  const cleanedCpf = cpf?.replace(/\D/g, '');

  if (cleanedCpf.length !== 11) {
    return cleanedCpf;
  }

  return cleanedCpf?.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
}

export const mascaraCnpj = (cnpj: string): string => {
  const cleanedCnpj = cnpj?.replace(/\D/g, '');

  if (cleanedCnpj.length !== 14) {
    return cleanedCnpj;
  }

  return cleanedCnpj?.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
}

export const mascaraCpfCnpj = (cpfcnpj: string): string => {
  if (!cpfcnpj || typeof cpfcnpj !== 'string') {
    return '';
  }

  const cleanedCpfCnpj = cpfcnpj.replace(/\D/g, '');

  if (cleanedCpfCnpj.length === 11) {
    return mascaraCpf(cleanedCpfCnpj);
  }

  if (cleanedCpfCnpj.length === 14) {
    return mascaraCnpj(cleanedCpfCnpj);
  }

  return cpfcnpj;
};

